import React, { useEffect } from 'react';
import loading from '../../assets/loading.gif';
import './loader.css';

const Loader = () => {
    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    return (
        <div className="loader-bg">
            <div className='loader'>
                <img src={loading} alt='loading-img'/>
            </div>
        </div>
    );
};

export default Loader;